<template>
  <ul class="file-list p-2">
    <file-item
      v-for="(file, idx) in list"
      :key="`${file.name}-${idx}`"
      :src.sync="file.src"
      :file-name.sync="file.name"
      :desc.sync="file.desc"
      :file-src.sync="file.obj"
      :idx="idx"
      @delete-file="deleteFile"
    ></file-item>

    <div
      class="add-file-btn text-gray-400 font-medium bg-transparent duration-150 hover:bg-gray-200 mt-2 ml-2 rounded-md py-2 pl-2 cursor-pointer"
      @click="addTempFile"
      v-if="canAddFile"
    >
      <md-icon class="duration-150">add</md-icon>
      <span>{{ $t("student.add_file") }}</span>
    </div>
  </ul>
</template>

<script>
import FileItem from "./FileItem.vue";

const defaultNewFile = () => ({
  src: "",
  name: "",
  desc: "",
  obj: null
});

export default {
  props: ["listName", "list", "canAddFile"],
  components: { FileItem },
  data() {
    return {};
  },
  methods: {
    addTempFile() {
      const newList = [...this.list, defaultNewFile()];

      this.$emit("update:list", newList);
    },
    deleteFile(idx) {
      const newList = [...this.list.slice(0, idx), ...this.list.slice(idx + 1)];

      this.$emit("update:list", newList);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-file-btn {
  width: fit-content;
  padding-right: 11px !important;
}
</style>
